import { useReduxSelector } from '../../../hooks';
import { rootStateBranchSelector } from '../../../utils/rootStateBranchSelector';
import type { BrowserPageState } from '../slice';

export const browserPageSelector = rootStateBranchSelector('browserPage');

export function useBrowserPageSelector(): BrowserPageState {
  return useReduxSelector(browserPageSelector);
}
